var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.667v2.667a1.333 1.333 0 0 1-1.333 1.333H3.333A1.333 1.333 0 0 1 2 13.334v-2.667M10.667 4 8 1.333m0 0L5.333 4M8 1.333v6",
    stroke: "#500D76",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.807 10.843c.107 0 .184.032.232.096.054.064.08.15.08.256v1.056a.412.412 0 0 1-.424.416H4.311a.417.417 0 0 1-.256-.072c-.064-.053-.096-.133-.096-.24v-.312c0-.107.032-.184.096-.232a.387.387 0 0 1 .256-.08h.144V8.003h-.144a.417.417 0 0 1-.256-.072c-.064-.053-.096-.133-.096-.24v-.312c0-.107.032-.184.096-.232a.374.374 0 0 1 .248-.08h1.752c.102 0 .184.027.248.08.064.048.096.125.096.232v.312c0 .107-.032.187-.096.24a.402.402 0 0 1-.248.072h-.48v3.728h1.608v-.536c0-.107.024-.192.072-.256.054-.064.134-.096.24-.096h.312zM9.085 12.667v-.576h.94v-1.819l-.625.486-.299-.411 1.126-1.072h.437v2.816h.939v.576H9.085z",
    fill: "#500D76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadLogoColor);
export default __webpack_public_path__ + "static/media/uploadLogoColor.05d9ded0dea6139aad785a95fdc19530.svg";
export { ForwardRef as ReactComponent };